import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../../../../charts/d3/candlestickchart/newCandleChart/hoverBox/HoverBox';

type Props = {
  size: number;
  scaleY: (value: number) => number;
  portalRef: {
    current: any;
  };
};

export const SimpleBounceLine = observer(
  ({ size, scaleY, portalRef }: Props) => {
    const tradePlanForm: TradePlanData | null = useTradePlanFormStore() ?? null;
    if (!tradePlanForm) return null;
    const breakDetails = tradePlanForm.setupDetails.BOUNCE;
    const priceToBreak = breakDetails.priceToBreak;
    const json = {
      Category: 'Setup',
      Type: 'Bounce',
      'Break Price': ApplyRounding(Number(priceToBreak), 2),
    };

    return (
      <>
        {scaleY ? (
          <>
            <line
              stroke={colors.blue}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            ></line>
            <HoverBox
              size={size}
              json={json}
              topBoundary={scaleY(Number(priceToBreak)) - 2}
              bottomBoundary={scaleY(Number(priceToBreak)) + 2}
              leftBoundary={0}
              rightBoundary={size}
              portalRef={portalRef}
            />
          </>
        ) : null}
      </>
    );
  }
);
